module.exports = __webpack_public_path__ + "static/media/modal-2-body-brunello.75eaaa16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/MatchingRules/modal-2-body-brunello.svg
// module id = ./src/MatchingRules/modal-2-body-brunello.svg
// module chunks = 0